import React from 'react';
import { withTranslation } from 'react-i18next';
import ScrollContainer from 'react-indiana-drag-scroll'
import './HomeReferences.css';

class HomeReferences extends React.Component {
    constructor(props) {
        super(props);
        this.state =
        {
            src: [
                {'path': '/images/logos/BMVIT.webp'},
                {'path': '/images/logos/BRAC.webp'},
                {'path': '/images/logos/Castrol.webp'},
                {'path': '/images/logos/Degener.webp'},
                {'path': '/images/logos/KFV.webp'},
                {'path': '/images/logos/LandOOE.webp'},
                {'path': '/images/logos/SpringerFachmedien.webp'},
                {'path': '/images/logos/Unilever.webp'},
            ]
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.startAnimation);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.startAnimation);
    }

    startAnimation() {
        let element = document.querySelector('.App-home-references-tabs');
        let position = element.getBoundingClientRect();
        if (position.top >= 0 && position.bottom <= window.innerHeight) {
            element.classList.add('animation')
        } else {
            element.classList.remove('animation')
        }
    }

    getNameFromPath(path) {
        try {
            if (path && path.length > 0) {
                return path.split('/').pop().split('.').shift();
            }
        }
        catch (e) {}
        return '';         
    }

    render() {
        let tabItems = [];
        for (let i = 0; i < this.state.src.length; i++) {
            let tabItemSrc = this.state.src[i].path;
            let tabItemAlt = this.getNameFromPath(tabItemSrc);
            let tabItem = (
                <div key={`tab-item-${i}`} className="App-home-references-tab-item">
                    <img src={tabItemSrc} alt={tabItemAlt} />
                </div>
            );
            tabItems.push(tabItem);
        }

        return (
            <div className="App-home-references">
                <div className="App-home-references-text">{this.props.t('HomeReferences.Header')}</div>
                <div className="App-home-references-tabs-container">
                    <ScrollContainer className="App-home-references-tabs">
                        {tabItems}
                    </ScrollContainer>
                </div>
            </div>
        );
    }
}

export default withTranslation()(HomeReferences);